import React from "react";
import {Table} from "antd";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";
import {debounce} from "lodash";
import AutoSizer from "../../component/autosizer";
import paginationStyles from "../pagination/style/Pagination.less";
import styles from "./style/index.less";

import FunctionUtil from "../../util/FunctionUtil";

export default class CustomTable extends React.PureComponent {
    static defaultProps = {
        type: "normal", // 定义样式
        pagination: {},
        scrollYOffset: 32 + 52, // scrollY 减去的值，如果thead高度固定的话直接传进来
        showRowPointer: false,
        descHeaderZIndex: false,
    };

    static propTypes = {
        type: PropTypes.oneOf(["bordered", "normal", "background", "background-noborder"]),
        pagination: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
        scrollYOffset: PropTypes.number,
        columns: PropTypes.array.isRequired,
        showRowPointer: PropTypes.bool, // 移动到行的时候显示指针，并且 row hover 改变颜色（目前只加在了background-noborder）
        descHeaderZIndex: PropTypes.bool, // 设置列resizable时，fixed的表头需要重新设置下zIndex，保证handle正常显示
    };

    constructor(...args) {
        super(...args);
        this.state = {
            theadHeight: 0,
            paginationHeight: 0,
        };
        this.tableRef = null;
        this.deboundResize = debounce(this.onResize, 250, {trailing: true, leading: true});
        this.pagination = {
            className: paginationStyles["renyuan-pagination"],
            size: "small",
            showSizeChanger: true,
            hideOnSinglePage: true,
            pageSizeOptions: [20, 30, 50],
            defaultPageSize: 20,
            style: {
                paddingTop: 12,
            },
        };
    }

    componentDidMount = () => {
        document.addEventListener("resize", this.deboundResize);
        this.deboundResize();
    }

    componentWillUnmount = () => {
        this.deboundResize.cancel();
        document.removeEventListener("resize", this.deboundResize);
    }

    componentDidUpdate(prevProps) {
        if (this.props !== prevProps) {
            this.deboundResize();
            if (this.props.descHeaderZIndex) {
                this.setFixedHeaderZIndex();
            }
        }
    }

    setFixedHeaderZIndex = () => {
        const el = ReactDOM.findDOMNode(this);
        const thead = el.querySelector("thead");
        if (thead) {
            const leftElems = thead.getElementsByClassName("renyuan-table-cell-fix-left");
            const rightElems = thead.getElementsByClassName("renyuan-table-cell-fix-right");
            const setZIndex = (elems) => {
                _.forEach(elems, (elem, index) => {
                    const size = elems.length;
                    elem.style.zIndex = size - index + 1;
                });
            };
            setZIndex(leftElems);
            setZIndex(rightElems);
        }
    }

    onResize = () => {
        this.getTheadHeight();
        this.getPaginationHeight();
    }

    getTheadHeight = () => {
        const el = ReactDOM.findDOMNode(this);
        const thead = el.querySelector("thead");
        console.log("thead", thead.offsetHeight);
        const theadHeight = thead.offsetHeight;

        this.setState({
            theadHeight,
        });
    }

    getPaginationHeight = () => {
        const el = ReactDOM.findDOMNode(this);
        const pagination = el.getElementsByClassName("renyuan-pagination")?.[0];
        let paginationHeight = 0;
        if (pagination != null) {
            paginationHeight = pagination.offsetHeight;
        }
        this.setState({
            paginationHeight,
        });
    }

    _getScrollX = (columns) => {
        let scrollX = 0;

        for (let i = 0; i < columns.length; i++) {
            
            const column = columns[i];
            if (column.width && typeof (column.width) === "number") {
                scrollX += column.width;
            } else if (column.minWidth && typeof (column.minWidth) === "number") {
                scrollX += column.minWidth; // 留一列传minWidth以此来达到 屏幕宽度变化时 其他列宽度不变，这一列自适应宽度
            } else {
                scrollX = 0;
                break;
            }
        }

        return scrollX;
    }

    getScrollX = FunctionUtil.memoize(this._getScrollX)

    render() {
        const {type, pagination, scrollYOffset, columns, showRowPointer, ...restProps} = this.props;
        const scrollX = this.getScrollX(columns);
        const scrollY = scrollYOffset !== 0 ? scrollYOffset : this.state.theadHeight + this.state.paginationHeight + 12;
        return (
            <AutoSizer>
                {
                    ({height, width}) => {
                        return (
                            <Table
                                prefixCls="renyuan-table"
                                className={`${styles[type] ?? ""} ${showRowPointer ? "renyuan-table-row-pointer" : ""}`}
                                pagination={pagination === false ? false : {...this.pagination, ...pagination}}
                                bordered
                                columns={columns}
                                scroll={{x: scrollX !== 0 ? scrollX : true, y: height - scrollY}}
                                {...restProps}
                                style={{
                                    height,
                                    width,
                                    overflow: "none",
                                    maxWidth: "none",
                                }}
                            />
                        );
                    }
                }
            </AutoSizer>
        );
    }
}
